// extracted by mini-css-extract-plugin
export default {"items":"items_items__CPeyV","features":"items_features__R8liA"};